import { types, Instance, castToSnapshot, onAction, getRoot } from 'mobx-state-tree';
import { Organization } from './Organization';
import { SupportedMapLayers } from './enums';
import { CropzoneBoard } from './pages/CropzoneBoard';
import { MonitoringPage } from './pages/MonitoringPage';
import { ManagementPage } from './pages/ManagementPage';
import { LFMap } from './MapStore';
import { ActivityBoard } from './pages/ActivityBoard';
import { CropzoneModal } from './CropzoneModal';
import localforage from 'localforage';
import { IRootStoreAny } from './rootUtilType';
export const UiStore = types.model('UiStore', {
  isLoading: types.boolean,
  sidebar: types.model({
    open: true
  }).actions(self => ({
    toggleSidebar() {
      self.open = !self.open;
    }
  })),
  management: types.optional(ManagementPage, () => ManagementPage.create({
    invitationModal: {
      visible: false
    },
    fieldModal: {
      visible: false,
      dragging: false,
      brush: true
    }
  })),
  currentOrganization: types.safeReference(types.late(() => Organization), {
    get(id: string, parent) {
      const store = getRoot<IRootStoreAny>(parent).organizationsStore;
      return store.organizations?.find(x => x.id === id) || store.organizations?.[0];
    },
    set(value) {
      return value.id;
    }
  }),
  monitoringPage: types.optional(MonitoringPage, () => MonitoringPage.create()),
  lfmap: types.optional(LFMap, () => LFMap.create({
    location: [],
    rulerEnabled: false,
    hint: null,
    centreMarker: {
      isOnAnyPoint: false,
      isOnBoundary: false,
      isOnFirstPoint: false
    },
    layerInfoSheet: {}
  })),
  cropzoneBoard: types.optional(CropzoneBoard, () => CropzoneBoard.create({
    filter: {
      sort: {
        sortType: 'planting_date',
        order: 'desc'
      }
    }
  })),
  activityBoard: types.optional(ActivityBoard, () => ActivityBoard.create()),
  cropzoneModal: types.optional(CropzoneModal, () => CropzoneModal.create())
}).actions(self => ({
  setIsLoading(loading: boolean) {
    self.isLoading = loading;
  },
  setCurrentOrganizationId(id: string) {
    self.currentOrganization = castToSnapshot(id);
  }
})).views(self => ({
  get isReady() {
    return !self.isLoading;
  },
  get isStaging() {
    return process.env.NEXT_PUBLIC_RUN_ENV === 'staging' || process.env.NEXT_PUBLIC_RUN_ENV === 'development' || process.env.NEXT_PUBLIC_RUN_ENV === 'test';
  }
}));
export type IUiStore = Instance<typeof UiStore>;
export const uiStore = UiStore.create({
  isLoading: true,
  sidebar: {
    open: true
  },
  management: {
    invitationModal: {
      visible: false
    },
    fieldModal: {
      visible: false,
      dragging: false,
      brush: true
    }
  },
  monitoringPage: {
    mapLayerMap: {
      currentTab: SupportedMapLayers.NONE,
      layers: Object.values(SupportedMapLayers).map(mapLayerType => ({
        layerType: mapLayerType,
        isLoading: false
      }))
    },
    searchQuery: ''
  },
  lfmap: {
    location: [],
    rulerEnabled: false,
    hint: null,
    vis: [],
    centreMarker: {
      isOnAnyPoint: false,
      isOnBoundary: false,
      isOnFirstPoint: false
    },
    layerInfoSheet: {}
  },
  cropzoneBoard: {
    filter: {
      sort: {
        sortType: 'planting_date',
        order: 'desc'
      }
    }
  },
  activityBoard: {},
  cropzoneModal: {}
});
onAction(uiStore, call => {
  if (call.name == 'setCurrentOrganizationId') {
    localforage.setItem('currentOrganizationId', call?.args?.[0]);
    uiStore?.management?.resetPageCount();
  }
});